import React, { useEffect } from "react";

/**
 * FocusModeFlash, a gentle, ~1.3s full-screen animation that plays the moment
 * a learner hides the site menu and drops into Focus Mode inside the Academy.
 * A calming vignette darkens the edges while a "🎯 Focus Mode" badge breathes
 * in and out, signalling deep-work time. Purely decorative + non-blocking
 * (pointer-events: none) so it never interrupts the lesson underneath.
 */
const FocusModeFlash = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(() => onDone && onDone(), 1300);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div
      data-testid="focus-mode-flash"
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9998,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: "focusFlashFade 1.3s ease-in-out forwards",
        background:
          "radial-gradient(circle at center, rgba(2,6,23,0) 38%, rgba(2,6,23,0.55) 100%)",
      }}
    >
      <style>{`
        @keyframes focusFlashFade {
          0%   { opacity: 0; }
          18%  { opacity: 1; }
          78%  { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes focusBadgePop {
          0%   { transform: scale(0.82); opacity: 0; }
          22%  { transform: scale(1.06); opacity: 1; }
          40%  { transform: scale(1); }
          80%  { transform: scale(1); opacity: 1; }
          100% { transform: scale(0.96); opacity: 0; }
        }
        @keyframes focusRing {
          0%   { transform: scale(0.7); opacity: 0.7; }
          100% { transform: scale(1.9); opacity: 0; }
        }
      `}</style>

      <div style={{ position: "relative", animation: "focusBadgePop 1.3s ease-in-out forwards" }}>
        <span
          style={{
            position: "absolute",
            inset: -18,
            borderRadius: 999,
            border: "2px solid rgba(245,158,11,0.7)",
            animation: "focusRing 1.1s ease-out forwards",
          }}
        />
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "14px 26px",
            borderRadius: 999,
            background: "linear-gradient(135deg,#f59e0b,#f43f5e)",
            color: "#fff",
            fontWeight: 900,
            fontSize: 18,
            letterSpacing: 0.4,
            border: "2px solid rgba(255,255,255,0.75)",
            boxShadow: "0 10px 40px rgba(245,158,11,0.55)",
          }}
        >
          <span style={{ fontSize: 22 }}>🎯</span>
          <span>Focus Mode</span>
        </div>
      </div>
    </div>
  );
};

export default FocusModeFlash;
